import { useDispatch, useSelector } from 'react-redux'
import { ShowAllIndustryCheckbox } from '../../../../ShowAllIndustryCheckbox'
import {
  changeIsShowValueData,
  selectIsShowValueData,
} from '../../../store/slice'

export const ShowAllIndustry = () => {
  const dispatch = useDispatch()

  const isShow = useSelector(selectIsShowValueData)

  const onClick = () => {
    dispatch(changeIsShowValueData(!isShow))
  }

  return <ShowAllIndustryCheckbox isShow={isShow} onClick={onClick} />
}
